/** localStorage can throw (private mode, blocked storage). These helpers never do. */
export function readJson<T>(key: string, fallback: T): T {
  try {
    const raw = window.localStorage.getItem(key);
    return raw === null ? fallback : (JSON.parse(raw) as T);
  } catch {
    return fallback;
  }
}

export function writeJson(key: string, value: unknown): void {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* storage unavailable: settings just won't persist */
  }
}

/** Per-tab storage for reconnect tokens: never shared via links, survives a refresh. */
export const seatStorage = {
  get(code: string): string | null {
    try {
      return window.sessionStorage.getItem(`tpubg:seat:${code}`);
    } catch {
      return null;
    }
  },
  set(code: string, token: string): void {
    try {
      window.sessionStorage.setItem(`tpubg:seat:${code}`, token);
    } catch {
      /* ignore */
    }
  },
  clear(code: string): void {
    try {
      window.sessionStorage.removeItem(`tpubg:seat:${code}`);
    } catch {
      /* ignore */
    }
  },
};
